module.exports = __webpack_public_path__ + "static/media/selo-footer.11749f62.svg";